<div
  class="editable-container h-100"
  [class.dark-theme]="isDarkTheme"
  [class]="containerClass"
  [class.edit-mode]="inEditMode && !disableInEditMode"
  [class.disable-edit]="disableEditable"
  (dblclick)="editable && !disableEditable && (!inEditMode) && editModeChanged(true)"
>
  <div class="edit-wrapper d-flex flex-row-reverse">
    <button *ngIf="!disableEditable && !inEditMode && editable && !hideEditButton" id="editSection" class="edit-pen btn-dark-fill pointer" (click)="editModeChanged(true)">EDIT</button>
    <ng-content *ngIf="!disableEditable && !inEditMode && editable"  select="[extra-buttons]"></ng-content>
    <ng-content select="[search-button]"></ng-content>
  </div>
  <ng-content formData></ng-content>
  <div class="cancel-save action-button edit-mode" *ngIf="inEditMode && !disableInEditMode">
    <button class="btn btn-dark-fill cancel" (click)="cancelClickedEvent()">CANCEL</button>
    <sm-loading-button
      *ngIf="!hideSaveButton"
      [disabled]="disableSave" label="SAVE"
      [loading]="saving"
      (click)="!disableSave && !saving && saveSection()"
      class="action-button"></sm-loading-button>
  </div>
</div>
